import { render, staticRenderFns } from "./location-item.vue?vue&type=template&id=b3327a02&"
import script from "./location-item.vue?vue&type=script&lang=js&"
export * from "./location-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "location-item.vue"
export default component.exports